import store from "@/lib/backendCall/store"
import nft from "@/lib/backendCall/nft"
import purchasable from "@/lib/backendCall/purchasable";
import redeemable from "@/lib/backendCall/redeemable";
import proposal from "@/lib/backendCall/proposal";
import faucet from "@/lib/backendCall/faucet";

export default {
    store,
    nft,
    purchasable,
    redeemable,
    proposal,
    faucet
}